import {NavLink} from 'react-router-dom';
import React, {Component} from 'react';

export default class ReportPrintButton extends Component {

	render() {
		const {customerId, reportId} = this.props;
		return (
			<NavLink to={`/customer/${customerId}/reports/${reportId}/print`} className='btn btn-primary'>
				<i className={'fa fa-print'}> </i> Bericht drucken
			</NavLink>
		)
	}
}
